<template>
  <div class="modal-mask" role="dialog">
    <div class="overlay-mask">
      <div class="modal-dialog modal-md">
        <div class="modal-content modal-edit-bg">
          <div class="modal-body">
            <div class="row">
              <div
                class="col-lg-12 col-md-12 col-sm-12 col-xs-12 edit_account_modal"
              >
                <div class="close_btn" v-on:click="CloseModal()"></div>
                <br />
                <div class="row">
                  <div class="" style="width: 100%; padding: 1px;">
                    <iframe
                      id="JotFormIFrame-201614063686050"
                      title="Equipment Request Form"
                      onload="window.parent.scrollTo(0,20)"
                      allowtransparency="true"
                      allowfullscreen="true"
                      allow="geolocation; microphone; camera"
                      :src="
                        'https://form.jotform.com/201614063686050?' +
                        prefillFields
                      "
                      frameborder="0"
                      style="min-width: 100%; height: 800px; border: none;"
                      scrolling="yes"
                    >
                    </iframe>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["Account", "orderType"],
  components: {},
  data() {
    return {
      isModalShown: false,
    };
  },
  methods: {
    CloseModal() {
      this.$emit("closeWufoo");
    },
    ShowWufoo(salesforceId) {
      var _this = this;
      var organizationName =
        _this.Account.accountType === 1
          ? _this.Account.primaryContact.firstName +
            " " +
            _this.Account.primaryContact.lastName +
            " " +
            _this.Account.primaryContact.suffix
          : _this.Account.primaryContact.legalName;
      var ifr = document.getElementById("JotFormIFrame-201614063686050");
      if (window.location.href && window.location.href.indexOf("?") > -1) {
        var get = window.location.href.substr(
          window.location.href.indexOf("?") + 1
        );
        if (ifr && get.length > 0) {
          var src = ifr.src;
          src = src.indexOf("?") > -1 ? src + "&" + get : src + "?" + get;
          ifr.src = src;
        }
      }
      window.handleIFrameMessage = function (e) {
        if (typeof e.data === "object") {
          return;
        }
        var args = e.data.split(":");
        if (args.length > 2) {
          iframe = document.getElementById(
            "JotFormIFrame-" + args[args.length - 1]
          );
        } else {
          iframe = document.getElementById("JotFormIFrame");
        }
        if (!iframe) {
          return;
        }
        switch (args[0]) {
          case "scrollIntoView":
            iframe.scrollIntoView();
            break;
          case "setHeight":
            iframe.style.height = args[1] + "px";
            break;
          case "collapseErrorPage":
            if (iframe.clientHeight > window.innerHeight) {
              iframe.style.height = window.innerHeight + "px";
            }
            break;
          case "reloadPage":
            window.location.reload();
            break;
          case "loadScript":
            var src = args[1];
            if (args.length > 3) {
              src = args[1] + ":" + args[2];
            }
            var script = document.createElement("script");
            script.src = src;
            script.type = "text/javascript";
            document.body.appendChild(script);
            break;
          case "exitFullscreen":
            if (window.document.exitFullscreen)
              window.document.exitFullscreen();
            else if (window.document.mozCancelFullScreen)
              window.document.mozCancelFullScreen();
            else if (window.document.mozCancelFullscreen)
              window.document.mozCancelFullScreen();
            else if (window.document.webkitExitFullscreen)
              window.document.webkitExitFullscreen();
            else if (window.document.msExitFullscreen)
              window.document.msExitFullscreen();
            break;
        }
        var isJotForm = e.origin.indexOf("jotform") > -1 ? true : false;
        if (
          isJotForm &&
          "contentWindow" in iframe &&
          "postMessage" in iframe.contentWindow
        ) {
          var urls = {
            docurl: encodeURIComponent(document.URL),
            referrer: encodeURIComponent(document.referrer),
          };
          iframe.contentWindow.postMessage(
            JSON.stringify({ type: "urls", value: urls }),
            "*"
          );
        }
      };
      if (window.addEventListener) {
        window.addEventListener("message", handleIFrameMessage, false);
      } else if (window.attachEvent) {
        window.attachEvent("onmessage", handleIFrameMessage);
      }
      this.isWufooLoading = false;
      this.prefillFields =
        "userSf=" +
        this.Account.portalUserSalesforceId +
        "&orderType=" +
        this.orderType +
        "&name[first]=" +
        this.Account.primaryContact.firstName +
        "&name[last]=" +
        this.Account.primaryContact.lastName +
        "&email=" +
        this.Account.emailAddress +
        "&address[addr_line1]=" +
        this.Account.primaryContact.officeLocation.streetAddress +
        "&address[addr_line2]=" +
        this.Account.primaryContact.officeLocation.suite +
        "&address[city]=" +
        this.Account.primaryContact.officeLocation.city +
        "&address[state]=" +
        this.Account.primaryContact.officeLocation.state +
        "&stateCode=" +
        this.Account.primaryContact.officeLocation.state +
        "&address[postal]=" +
        this.Account.primaryContact.officeLocation.zip;
    },
  },
  created() {
    this.isWufooLoading = true;
    var portalUserSalesforceId = localStorage.getItem("portalUserSalesforceId");
    this.ShowWufoo(portalUserSalesforceId);
  },
};
</script>



// WEBPACK FOOTER //
// FrameOrderForm.vue?54342b0e